import { h } from '@atomify/jsx';
import { Label } from '@atoms/label/label';
import { Marker, MarkerProps } from '@atoms/marker/marker';

import { HouseSelectorObjectHandler, HouseSelectorPointer } from './types';

export const renderPointer = (
    pointer: HouseSelectorPointer,
    pointerProps?: { onPointerClick: HouseSelectorObjectHandler },
): Element => {
    if (!pointer.iconName) {
        return (
            <div
                class="house-selector__pointer house-selector__pointer--text"
                style={{
                    left: `${(pointer.point?.x || 0) * 100}%`,
                    top: `${(pointer.point?.y || 0) * 100}%`,
                }}>
                <Label text={pointer.label || ''} />
            </div>
        );
    }

    const markerProps: MarkerProps = { variant: '' };
    switch (pointer.iconName) {
        case 'entry':
            markerProps.variant = 'entrance';
            break;
        case 'interest':
            markerProps.variant = 'generic';
            break;
    }

    return (
        <Marker
            {...markerProps}
            classes="house-selector__pointer house-selector__pointer--marker"
            size="small"
            onClick={() => pointerProps?.onPointerClick(pointer)}
            style={{
                left: `${(pointer.point?.x || 0) * 100}%`,
                top: `${(pointer.point?.y || 0) * 100}%`,
            }}
        />
    );
};
